/* import main stylesheet */
import '../styles/main.scss';

import 'meteor-imports';

import '../universal/collections/simpleSchema.config';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';
import { render } from 'react-dom';
import React from 'react';
import { AppContainer } from 'react-hot-loader';
import { Map as iMap } from 'immutable';
import makeStore from './makeStore';
import Root from './Root';

import '../universal/collections/users/users';

import '../universal/collections/users/roles/god';
import '../universal/collections/users/roles/organizer';
import '../universal/collections/users/roles/partner';
import '../universal/collections/users/roles/pilot';

window.jQuery = require('jquery');
jQuery("html").addClass("default");
require('../../node_modules/messenger/build/js/messenger.min.js');
require('../../node_modules/messenger/build/js/messenger-theme-future.js');
require('../../node_modules/jquery.kinetic/jquery.kinetic.js');
require('moment-locale-fr');
require('moment').locale('fr');

import './userback';

Messenger.options = {
	'extraClasses': 'messenger-fixed messenger-on-center messenger-on-bottom'
};


if (process.env.NODE_ENV !== 'production') require('es6-promise').polyfill();

Meteor.startup(() => {
	const { router } = window.__INITIAL_STATE__;

	// routing is currently a regualr JS object. This may change in the future
	const initialState = iMap({
		router,
	});

	const store = makeStore(initialState);
	render(
		<AppContainer key={0}>
			<Root store={store} />
		</AppContainer>,
		document.getElementById('root')
	);

	let reloads = 0;

	// Hot Module Replacement API
	if (module.hot) {
		module.hot.accept('./Root', () => {
			const Root = require('./Root').default;
			render(
				<AppContainer key={++reloads}>
					<Root store={store} />
				</AppContainer>,
				document.getElementById('root')
			);
		});
	}
});



/** WEBPACK FOOTER **
 ** ./src/client/index.js
 **/